import React from 'react';
import ShieldBrokenIcon from '../../library/icons/shield-broken-icon';
import ButtonComponent from '../../library/components/button.component';
import { HIERARCHY } from '../../library/constants/constants';

const MagicLinkBrokenComponent = () => {
    const handleRedirectToLogin = () => {
        window.location.href = '/account/login';
    };

    return (
        <div className="magic-link-component">
            <div className="navbar">
                <div className="logo"></div>
                <div className="login">
                    <ButtonComponent
                        type={HIERARCHY.TERTIARY}
                        text="Log in"
                        onClick={() => handleRedirectToLogin()}
                    />
                </div>
            </div>
            <div className="content">
                <div className="linkcontent">
                    <div className="img">
                        <ShieldBrokenIcon />
                    </div>
                    <h2>This share link is broken</h2>
                    <p>Please contact your account manager to arrange a new share link</p>
                </div>
            </div>
        </div>
    );
};

export default MagicLinkBrokenComponent;
